import React from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css';
import Footer from '../Footer/FooterWrapper';
import { useLanguage } from '../../i18n/LanguageContext';

const Privacy = () => {
  const { t, tRaw } = useLanguage();
  const sections = tRaw('legal.privacySections') || [];

  return (
    <>
      <div className="privacy-container">
        <h2>{t('legal.privacyTitle')}</h2>

        {sections.map((section) => (
          <div className="privacy-item" key={section.title}>
            <h3>{section.title}</h3>
            {section.body.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        ))}

        <div className="cta-link">
          <Link to="/">
            <button className="cta-button">{t('legal.backHome')}</button>
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Privacy; 
